import 'swiper/css';
import get from 'lodash/get';
import { GetServerSideProps } from 'next';

import { MOBILE_USER_AGENTS } from 'core/constants/mobile-user-agents';
import { fetchPageContext, PageContextOptions } from 'core/services/context';
import { CommonPageContext, StarredPageContext } from 'core/services/context/context';
import { StarredService } from 'core/services/context/starred';
import { getQueryParamsWithUrl } from 'core/utils/filters/search-filter';

import { Text } from 'components/common/text/text';
import { FlatListGroupPageType } from 'components/flat/flat-list-grouped-by-city/flat-list-group';
import { FlatListGroupedByCity } from 'components/flat/flat-list-grouped-by-city/flat-list-grouped-by-city';
import { Page } from 'components/page/page';

interface StarredPageProps {
  context: {
    common: CommonPageContext;
    extra: StarredPageContext;
  };
  isMobileDevice: boolean;
}

const StarredPage = (props: StarredPageProps) => {
  const mainHost = props.context.common.host ? props.context.common.host : '';

  return (
    <Page
      hasSearchBar
      ctx={{
        ...props.context.common,
        seo: {
          ...props.context.common.seo,
          title: 'Сервис бронирования жилья «Квартирка»: посуточная аренда квартир, домов, апартаментов'
        }
      }}
    >
      <>
        <Text As={'h1'} size={28} desktopSize={36}>
          Закладки
        </Text>
        {props.context.extra.flats.length ? (
          <FlatListGroupedByCity
            mainHost={mainHost}
            flats={props.context.extra.flats}
            flatListGroupPage={FlatListGroupPageType.starred}
            isMobileDevice={props.isMobileDevice}
            hasMaskWhenRemove
          />
        ) : (
          <Text size={16}>В закладки пока ничего не добавлено</Text>
        )}
      </>
    </Page>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { res } = context;
  const mainHost = process.env.NEXT_PUBLIC_MAIN_HOST || '';
  const correlationID = get(context, 'req.headers.x-request-id', '') as string;
  const cookies = get(context, 'req.headers.cookie', '');
  const accept = get(context, 'req.headers.accept', '');
  const UA = context.req.headers['user-agent'];
  const isMobileDevice = Boolean(UA?.match(MOBILE_USER_AGENTS));
  const query = getQueryParamsWithUrl(context);

  const options: PageContextOptions<StarredPageContext> = {
    path: '/',
    host: mainHost,
    correlationID,
    cookies,
    authRequired: false,
    query,
    accept,
    extra: (accessToken: Optional<string>): Promise<StarredPageContext> => {
      const starredPageService = new StarredService(mainHost, correlationID, accessToken);
      const response = starredPageService.fetchContext(cookies, accept);
      return response;
    }
  };

  const pageContext = await fetchPageContext(options);

  if (pageContext) {
    if (pageContext.common['set-cookie']) {
      pageContext.common['set-cookie'].map((cookie) => {
        res.setHeader('Set-Cookie', cookie);
      });
    }
  }

  return {
    props: {
      context: pageContext,
      isMobileDevice
    }
  };
};

export default StarredPage;
